import styles from './NavigationItem.module.scss';
import type { NavigationItemProps } from './NavigationItem.types';

export const NavigationItem = ({ href, children, isClicked, onClick }: NavigationItemProps): JSX.Element => (
	<a href={href} className={isClicked ? styles.navigationItemClicked : styles.navigationItem} onClick={onClick}>
		{children}
	</a>
);
